<template>
  <div className="text-xs text-slate-400 px-4">
    by
    <a href="https://stafura.dev" target="_blank" className="underline"
      >stafura.dev</a
    >
  </div>
</template>
